export default {
  state: {
    keepAlive: null,
    oProfileId: 0,
    appId: "",
    profileId: "",
    openId: 0,
    sex: 0,
    age: 0,

    // themeColor: '0,122,255',
    // subThemeColor: '0,122,255',

    themeColor: "255,113,52",
    subThemeColor: "255,113,52",
    themeColorcc: "255,113,52",

    loginQnId: 3285050003001,
    monthQnId: 3285050004001,

    hasHealthEntrance: 1,
    logoPath: "",
    logoText: "健康助手基于目前对您的了解度所做出的健康综合评分",

    rvalueBaseDataList: null,
    archiveItem: null,
    hValue: 0,
    isHref: false,

    channelId: null,
    hasQuestionnaire: true,

    archiveJumpIndex: -1,
    archiveScrollTop: 0,
  },
  mutations: {
    setKeepAlive: (state, keepAlive) => {
      state.keepAlive = keepAlive;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setAppId: (state, appId) => {
      state.appId = appId;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setOProfileId: (state, oProfileId) => {
      state.oProfileId = oProfileId;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setProfileId: (state, profileId) => {
      state.profileId = profileId;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setOpenId: (state, openId) => {
      state.openId = openId;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setSex: (state, sex) => {
      state.sex = sex;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setAge: (state, age) => {
      state.age = age;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setThemeColor: (state, themeColor) => {
      state.themeColor = themeColor;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setSubThemeColor: (state, subThemeColor) => {
      state.subThemeColor = subThemeColor;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setHasHealthEntrance: (state, hasHealthEntrance) => {
      state.hasHealthEntrance = hasHealthEntrance;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setLoginQnId: (state, loginQnId) => {
      state.loginQnId = loginQnId;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setMonthQnId: (state, monthQnId) => {
      state.monthQnId = monthQnId;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setLogoPath: (state, logoPath) => {
      state.logoPath = logoPath;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setLogoText: (state, logoText) => {
      state.logoText = logoText;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setRvalueBaseDataList: (state, rvalueBaseDataList) => {
      state.rvalueBaseDataList = rvalueBaseDataList;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setArchiveItem: (state, archiveItem) => {
      state.archiveItem = archiveItem;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setHValue: (state, hValue) => {
      state.hValue = hValue;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setIsHref: (state, isHref) => {
      state.isHref = isHref;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setChannelId: (state, channelId) => {
      state.channelId = channelId;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setHasQuestionnaire: (state, hasQuestionnaire) => {
      state.hasQuestionnaire = hasQuestionnaire;
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setArchiveJumpIndex: (state, archiveJumpIndex) => {
      state.archiveJumpIndex = archiveJumpIndex;
      // console.log('archiveJumpIndex',archiveJumpIndex);
      sessionStorage.setItem("store", JSON.stringify(state));
    },
    setArchiveScrollTop: (state, archiveScrollTop) => {
      state.archiveScrollTop = archiveScrollTop;
      // console.log('archiveJumpIndex',archiveJumpIndex);
      sessionStorage.setItem("store", JSON.stringify(state));
    },
  },
  getters: {
    keepAlive(state) {
      if (!state.keepAlive) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.keepAlive = store;
      }
      return state.keepAlive;
    },
    appId(state) {
      if (!state.appId) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.appId = store.appId;
      }
      return state.appId;
    },
    profileId(state) {
      if (!state.profileId) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.profileId = store.profileId;
      }
      return state.profileId;
    },
    oProfileId(state) {
      if (!state.oProfileId) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.oProfileId = store.oProfileId;
      }
      return state.oProfileId;
    },
    openId(state) {
      if (!state.openId) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.openId = store.openId;
      }
      return state.openId;
    },
    sex(state) {
      if (!state.sex) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.sex = store.sex;
      }
      return state.sex;
    },
    age(state) {
      if (!state.age) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.age = store.age;
      }
      return state.age;
    },
    themeColor(state) {
      if (!state.themeColor) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.themeColor = store.themeColor;
      }
      return state.themeColor;
    },
    subThemeColor(state) {
      if (!state.subThemeColor) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.subThemeColor = store.subThemeColor;
      }
      return state.subThemeColor;
    },
    hasHealthEntrance(state) {
      if (!state.hasHealthEntrance) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.hasHealthEntrance = store.hasHealthEntrance;
      }
      return state.hasHealthEntrance;
    },
    loginQnId(state) {
      if (!state.loginQnId) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.loginQnId = store.loginQnId;
      }
      return state.loginQnId;
    },
    monthQnId(state) {
      if (!state.monthQnId) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.monthQnId = store.monthQnId;
      }
      return state.monthQnId;
    },
    logoPath(state) {
      if (!state.logoPath) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.logoPath = store.logoPath;
      }
      return state.logoPath;
    },
    logoText(state) {
      if (!state.logoText) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.logoText = store.logoText;
      }
      return state.logoText;
    },
    rvalueBaseDataList(state) {
      if (!state.rvalueBaseDataList) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.rvalueBaseDataList = store.rvalueBaseDataList;
      }
      return state.rvalueBaseDataList;
    },
    archiveItem(state) {
      if (!state.archiveItem) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.archiveItem = store.archiveItem;
      }
      return state.archiveItem;
    },
    hValue(state) {
      if (!state.hValue) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.hValue = store.hValue;
      }
      return state.hValue;
    },
    isHref(state) {
      if (!state.isHref) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.isHref = store.isHref;
      }
      return state.isHref;
    },
    channelId(state) {
      if (!state.channelId) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.channelId = store.channelId;
      }
      return state.channelId;
    },
    hasQuestionnaire(state) {
      if (!state.hasQuestionnaire) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.hasQuestionnaire = store.hasQuestionnaire;
      }
      return state.hasQuestionnaire;
    },
    archiveJumpIndex(state) {
      if (!state.archiveJumpIndex) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.archiveJumpIndex = store.archiveJumpIndex;
      }
      return state.archiveJumpIndex;
    },
    archiveScrollTop(state) {
      if (!state.archiveScrollTop) {
        let store = JSON.parse(sessionStorage.getItem("store"));
        state.archiveScrollTop = store.archiveScrollTop;
      }
      return state.archiveScrollTop;
    },
  },
};
